export default __webpack_public_path__ + "static/media/popup_remote_monitoring_graph.953eb8e8.jpg";